import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function SearchIconRaw({
  style,
  fill,
  width,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className: string;
  width?: number;
}) {
  return (
    <Svg
      width={width ?? 26}
      height={width ?? 24}
      viewBox="0 0 26 24"
      fill={fill}
      style={style}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 11C3.5 7.13401 6.63401 4 10.5 4C14.366 4 17.5 7.13401 17.5 11C17.5 14.866 14.366 18 10.5 18C6.63401 18 3.5 14.866 3.5 11ZM10.5 2C5.52944 2 1.5 6.02944 1.5 11C1.5 15.9706 5.52944 20 10.5 20C12.7143 20 14.7418 19.2004 16.3095 17.8741L20.1429 21.7075C20.5334 22.098 21.1666 22.098 21.5571 21.7075C21.9476 21.317 21.9476 20.6838 21.5571 20.2933L17.6848 16.421C18.8242 14.9132 19.5 13.0355 19.5 11C19.5 6.02944 15.4706 2 10.5 2Z"
        fill={fill}
      />
    </Svg>
  );
}

export const SearchIcon = nativewindWrapSvg(SearchIconRaw);
